<script setup>
import { Link } from '@inertiajs/vue3';
import logoPath from '../../../resources/imgs/logo-ncomandi.webp';
</script>

<template>
    <Link href="/" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
        <div class="flex items-center justify-center">
            <img :src="logoPath" alt="N'Comandi Logo" fetchpriority="high" width="382" height="281" class="h-8 w-auto object-contain" />
        </div>
        <div class="hidden sm:grid flex-1 text-left text-sm">
            <span class="mb-0.5 truncate font-semibold leading-none text-foreground">N'Comandi</span>
        </div>
    </Link>
</template>